import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { WhyAlphaPulse } from "@/components/landing/WhyAlphaPulse";
import { FeatureGrid } from "@/components/landing/FeatureGrid";
import { AnalyticsSection } from "@/components/landing/AnalyticsSection";
import { Community } from "@/components/landing/Community";
import { Nutrition } from "@/components/landing/Nutrition";
import { Testimonials } from "@/components/landing/Testimonials";
import { Pricing } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";
import { ContactSection } from "@/components/landing/ContactSection";
import { Footer } from "@/components/landing/Footer";

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [location]);

  return (
    <div className="bg-obsidian text-white min-h-screen overflow-x-hidden">
      <Header />
      <main>
        <Hero />
        <WhyAlphaPulse />
        <FeatureGrid />
        <AnalyticsSection />
        <Community />
        <Nutrition />
        <Testimonials />
        <Pricing />
        <FAQ />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
